<div class="feature-snap-scroll">
  @for (game of games; track game.key) {
    <a
      class="feature-snap-scroll__item"
      [matTooltip]="'Filter by ' + game.name"
      [class.feature-snap-scroll__item--selected]="isSelected(game)"
      [style.background-image]="'url(' + getGameImage(game) + ')'"
      (click)="onGameSelected(game)"
    >
      <img
        [src]="getGameImage(game)"
        [alt]="game.name"
        fzSrcError="/shared/img/all-sports.webp"
      />
    </a>
  }
</div>
